export class HospitalizationRegime {
    name: string;
    id: number;
    code: string;
}